import { app } from '../../../../app';
import { Controller } from './verify.controller';

app.component('verifyPhoneNumber', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./verify.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/phone-numbers/verify/verify.component.js